
export class EventEmitter2<T> {
    value: T;
    debugName: string;
    listeners: ((value: T) => void)[] = [];

    constructor(value: T, debugName: string) {
        this.value = value;
        this.debugName = debugName;
    }

    emit(newValue: T) {
        this.value = newValue;
        this.listeners.forEach(listener => listener(newValue));
    }

    subscribe(listener: (value: T) => void) {
        this.listeners.push(listener);

        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    // subscribe and immediately fire the listener with the current value. Returns
    // the same unsubscribe function as subscribe().
    subscribeAndFireLast(listener: (value: T) => void) {
        const unsubscribe = this.subscribe(listener);
        listener(this.value);
        return unsubscribe;
    }
}